import { userName } from "../../../util/formatter";

export default {
  slug: "supervisors",
  endpoint: "supervisors/",
  titleKey: "supervisors_title",
  defaultOrdering: "first_name",
  readOnly: true,
  columns: [
    { label: "f_name", format: row => userName(null, row), sort: "first_name" },
    { field: "phone_number", label: "f_phone" },
  ],
  deactivation: { field: "is_active", activeValue: true, via: "patch" },
  // read-only detail view (no editing) — shown by ResourceView; activate/deactivate available
  fields: [
    { name: "first_name", type: "text", label: "f_first_name" },
    { name: "last_name", type: "text", label: "f_last_name" },
    { name: "phone_number", type: "text", label: "f_phone" },
  ],
};
